// extracted by css-extract-rspack-plugin
export default {"cls1":"Cta-cls1_KIP","cls2":"Cta-cls2_svV Cta-cls1_KIP"};